<aca-libraries-base
  [list]="list"
  [isLoading]="isLoading"
  [pagination]="pagination"
  [columns]="columns"
  [navigateRoute]="'favorite/libraries'"
  [titleKey]="'APP.BROWSE.LIBRARIES.MENU.FAVORITE_LIBRARIES.TITLE'"
  [emptyTitleKey]="'APP.BROWSE.LIBRARIES.EMPTY_STATE.FAVORITE_LIBRARIES.TITLE'"
  [emptySubtitleKey]="'APP.BROWSE.LIBRARIES.EMPTY_STATE.FAVORITE_LIBRARIES.TEXT'"
  (changePageSize)="onChangePageSize($event)"
  (changePageNumber)="getList($event)"
  (nextPage)="getList($event)"
  (prevPage)="getList($event)"
/>
